import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import './i18n';
import styled from 'styled-components';
import { HomePage } from './pages/Home';
import { SideBar } from './components/SideBar';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { SaleStatute } from './pages/SaleStatute';
import { ReactComponent as Logo } from './logo.svg';
import { useWindowSize } from './hooks/useWindowSize';

const MainColumn = styled.div`
	width: 1120px;
	margin: 24px auto 0;
`;

const Header = styled.header`
	/* ${({ theme }) => theme.elevation.level1};
	position: sticky;
	top: 0;
	z-index: 10; */
	display: grid;
	grid-gap: 48px;
	grid-template-columns: 1fr auto auto;
	justify-items: end;
	margin-bottom: 80px;
`;

const StyledNavigation = styled(Navigation)`
	display: grid;
	grid-gap: 16px;
	grid-auto-flow: column;
	grid-auto-columns: fit-content(100px);
	align-items: center;
	justify-items: center;
`;

const StyledSocialBar = styled.div`
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: fit-content(100px);
	align-items: center;
	justify-items: center;
`;

const FacebookButton = styled.a`
	${({ theme }) => theme.iconButton({ icon: { name: 'facebook', color: '#888' } })};
`;

const LinkedInButton = styled.a`
	${({ theme }) => theme.iconButton({ icon: { name: 'linkedin', color: '#888' } })};
`;

const LogoLink = styled(Link)`
	justify-self: start;
	display: grid;
	grid-gap: 16px;
	grid-auto-flow: column;
	align-items: center;
	font-size: 1.6rem;
	text-decoration: none;
`;

const LogoText = styled.div`
	color: ${({ theme }) => theme.palette.primary.main};
`;

const links = [
	{ id: 'chapter1', label: 'Co u Ciebie?', to: '/home#co-u-ciebie' },
	{ id: 'chapter2', label: 'Zasilanie', to: '/home#zasilanie' },
	{ id: 'chapter3', label: 'Energia', to: '/home#energia' },
	{ id: 'chapter4', label: 'O mnie', to: '/home#o-mnie' },
];

export const App = () => {
	const [navigationOpen, setNavigationOpen] = useState(false);
	const windowSize = useWindowSize();
	const isMobileView = windowSize.width < 1024;

	return <BrowserRouter>
		<MainColumn data-testid="app">
			<Header>
				<LogoLink to="/"><Logo /><LogoText>Twój Projekt</LogoText></LogoLink>
				{isMobileView
					? <SideBar
						open={navigationOpen}
						onClose={() => setNavigationOpen(false)}
					>
						<StyledNavigation links={links} />
					</SideBar>
					: <StyledNavigation links={links} />
				}
				{/* <ActionInput /> */}
				<StyledSocialBar>
					<FacebookButton href="https://www.facebook.com/twojprojekt2020" target="_blank">facebook</FacebookButton>
					<LinkedInButton href="https://www.linkedin.com/in/paulina-k-a759a41a0/" target="_blank">linkedin</LinkedInButton>
				</StyledSocialBar>
			</Header>
			<main>
				<Routes>
					<Route path='/' element={<Navigate to='/home' />} />
					<Route path='/home' element={<HomePage />} />
					<Route path='/polityka-prywatnosci' element={<PrivacyPolicy />} />
					<Route path='/regulamin-sprzedazy' element={<SaleStatute />} />
				</Routes>
			</main>
		</MainColumn>
		<Footer />
	</BrowserRouter>
};